<template>
  <section class="authentication-form">
    <div class="innerpage-decor"></div>
    <div>
      <h2 class="title text-center"><router-link to="/"><img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand"></router-link></h2>
      <p class="text-center">Selamat datang di efunding, Silahkan Daftar.</p>
      <div class="card p-4 shadow-sm mx-auto responsive-card">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="theme-form" @submit.prevent="handleSubmit(handleRegister)">
            <div class="form-group text-center">
              <p class="mb-3 font-weight-bold">Daftar sebagai:</p>
              
              <div class="d-flex justify-content-center flex-nowrap">
                <div
                  class="select-card mx-2"
                  :class="{ active: form.userType === 'perorangan' }"
                  @click="form.userType = 'perorangan'"
                >
                  <img
                    src="@/assets/images/auth/img-individu-card.png"
                    alt="Perorangan"
                    class="img-select"
                  />
                </div>

                <div
                  class="select-card mx-2"
                  :class="{ active: form.userType === 'badan_hukum' }"
                  @click="form.userType = 'badan_hukum'"
                  >
                  <!-- ganti klik jadi form.userType = 'badan_hukum' -->
                  <img
                    src="@/assets/images/auth/img-company-card.png"
                    alt="Badan Hukum"
                    class="img-select"
                  />
                </div>
              </div>

              <small class="text-danger d-block mt-2" v-if="errors.userType">{{ errors.userType }}</small>
            </div>
            <div class="form-group">
              <ValidationProvider name="name" rules="required" required v-slot="{ errors }">
                <input type="text" v-model="form.name" class="form-control" :placeholder="form.userType === 'perorangan' ? 'Nama Lengkap Sesuai KTP'  : 'Nama Pengurus/Direktur (Sesuai KTP)' " name="name">
                <small class="text-danger ml-3">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider name="email" rules="required|email" required v-slot="{ errors }">
                <input type="email" v-model="form.email" class="form-control" :placeholder="form.userType === 'perorangan' ? 'Masukkan Email'  : 'Masukan Email Pengurus/Direktur'" name="email">
                <small class="text-danger ml-3">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <!-- Bagian nomor telepon -->
            <div class="form-group position-relative">
              <ValidationProvider name="phoneNumber" rules="required|integer" required v-slot="{ errors }">
                <div style="position: relative;">
                  <span style="position: absolute; top: 50%; left: 15px; transform: translateY(-50%); font-size: 12px; color: #000;">
                    +62
                  </span>
                  <input
                    type="number"
                    v-model="form.no_telpon"
                    class="form-control"
                    :placeholder="form.userType === 'perorangan' ? 'Nomor HP yang terhubung Whatsapp'  : 'Nomor HP Pengurus/Direktur yang terhubung Whatsapp'"
                    name="phoneNumber"
                    style="padding-left: 45px; border-radius: 30px;"
                    @focus="phoneFocused = true"
                    @blur="phoneFocused = false"
                  />
                </div>
                <small class="text-danger ml-3 d-block" style="margin-top: 4px;">{{ errors[0] }}</small>
                <small
                  v-if="phoneFocused && form.no_telpon"
                  class="ml-3 d-block"
                  style="font-size: 12px; color: #007bff;"
                >
                  Nomor yang terhubung WhatsApp. contoh +62 878xxxxxx90
                </small>
              </ValidationProvider>
            </div>
            <div class="form-group">
            <ValidationProvider name="password" rules="required" v-slot="{ errors }">
                <div class="password-container">
                  <input :type="showpassword ? 'password' : 'text'" v-model="form.password" name="password" class="form-control" placeholder="Password" 
                    @focus="passwordFocused = true" @blur="passwordFocused = false" @input="checkPasswordCriteria">
                  <div v-on:click="showpassword = !showpassword" class="show-hide">
                    <span :class="{ show: showpassword }"></span>
                  </div>
                </div>
                <div class="row ml-3">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
                <!-- Menampilkan kriteria password hanya jika password diinputkan dan kursor berada di input -->
                <div v-if="passwordFocused && form.password && !passwordValid">
                  <div class="password-criteria">
                    <ul>
                      <li :style="{ color: passwordCriteria.uppercase ? 'green' : 'red' }">Harus ada huruf besar</li>
                      <li :style="{ color: passwordCriteria.lowercase ? 'green' : 'red' }">Harus ada huruf kecil</li>
                      <li :style="{ color: passwordCriteria.number ? 'green' : 'red' }">Harus ada angka</li>
                      <li :style="{ color: passwordCriteria.specialChar ? 'green' : 'red' }">Harus ada karakter khusus</li>
                    </ul>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <!-- Konfirmasi Password -->
            <div class="form-group">
              <ValidationProvider name="confirmPassword" rules="required|confirmed:password" v-slot="{ errors }">
                <input :type="showConfirmPassword ? 'password' : 'text'" v-model="form.confirmPassword" name="confirmPassword" class="form-control" placeholder="Konfirmasi Password">
                <div v-on:click="showConfirmPassword = !showConfirmPassword" class="show-hide">
                  <span :class="{ show: showConfirmPassword }"></span>
                </div>
                <div class="row ml-3">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </div>
            <!-- kode referal -->
            <div class="form-group">
              <ValidationProvider name="referalCode" v-slot="{ errors }">
                <input type="text" :disabled="disableReferralInput" v-model="form.referral_code" name="referalCode" class="form-control mt-5" placeholder="Kode Referral (Jika Ada)">
                <div class="row ml-3">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </div>

            <div class="form-group">
              <ValidationProvider name="terms" rules="required" v-slot="{ errors }">
                <div class="custom-control custom-checkbox">
                  <!-- Checkbox: tetap memicu modal untuk persetujuan -->
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="termsCheckbox"
                    v-model="form.acceptTerms"
                    @change="onTermsCheckboxChanged"
                    @click.prevent="openTermsModal"
                  />
                  <label class="custom-control-label" for="termsCheckbox">
                    Saya setuju dengan
                    <router-link to="/syarat-dan-ketentuan" target="_blank" @click.stop="">Syarat dan Ketentuan</router-link>
                    dan
                    <router-link to="/kebijakan-privasi" target="_blank" @click.stop="">Kebijakan Privasi</router-link>
                  </label>
                  <small class="text-danger ml-3">{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </div>

            <div class="my-5 d-flex justify-content-center">
              <VueRecaptcha
                ref="captcha"
                :sitekey="sitekey"
                @verify="onVerify"
                @expired="onExpired"
              />
            </div>

            <div class="form-button text-center">
              <button
                type="submit"
                class="btn btn-custom btn-lg theme-color"
                :disabled="loading || !form.acceptTerms || !recaptchaVerified"
              >
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>Daftar</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
        <p class="text-center mt-4">
          Sudah punya akun?
          <router-link to="/login" class="font-weight-bold text-primary">Login</router-link>
        </p>
      </div>
    </div>
    <b-modal size="l" v-model="emailNullModal">
      <div class="d-block text-center">
        <h3>Email Anda belum terverifikasi.<br>Silahkan cek Email Anda!</h3>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="oke">Oke</b-button>
      </template>
    </b-modal>
    <CustomModal v-if="modalVisible" :action="modalAction" @close="modalVisible = false">
      <h4 v-if="modalAction === 'success'">Registrasi Berhasil</h4>
      <h4 v-else>Registrasi Gagal</h4>

      <p v-html="modalMessage"></p>

      <div class="modal-button-group">
        <button
          class="custom-btn danger"
          @click="modalVisible = false"
        >
          Tutup
        </button>

        <button
          class="custom-btn primary"
          v-if="modalAction === 'success'"
          @click="$router.push('/login')"
        >
          Ke Login
        </button>
      </div>
    </CustomModal>
    <newCustomModal :visible="showTermsModal" size="large" @close="showTermsModal = false">
      <div class="terms-tabs mb-4">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'snk' }" 
              href="javascript:void(0)" 
              @click="activeTab = 'snk'"
            >
              Syarat & Ketentuan
            </a>
          </li>
          <li class="nav-item">
            <a 
              class="nav-link" 
              :class="{ active: activeTab === 'privacy', disabled: !snkScrolled }" 
              href="javascript:void(0)" 
              @click="snkScrolled ? activeTab = 'privacy' : null"
            >
              Kebijakan Privasi
            </a>
          </li>
        </ul>
      </div>

      <div
        ref="termsContent"
        class="scroll-wrapper"
        @scroll.passive="handleScroll"
      >
        <div v-show="activeTab === 'snk'">
          <div v-if="loadingTerms" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
            <p class="mt-2">Memuat konten...</p>
          </div>
          <div v-else class="dynamic-content">
             <div v-html="snkContent || '<p>Syarat dan Ketentuan tidak tersedia.</p>'"></div>
          </div>
        </div>
        <div v-show="activeTab === 'privacy'">
          <div v-if="loadingPrivacy" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
            <p class="mt-2">Memuat konten...</p>
          </div>
          <div v-else class="dynamic-content">
             <div v-html="privacyContent || '<p>Kebijakan Privasi tidak tersedia.</p>'"></div>
          </div>
        </div>
      </div>

      <div class="mt-3">
          <span v-if="activeTab === 'snk' && !snkScrolled">Silakan baca hingga akhir Syarat & Ketentuan...</span>
          <span v-else-if="activeTab === 'privacy' && !privacyScrolled">Silakan baca hingga akhir Kebijakan Privasi...</span>
          <span v-else-if="snkScrolled && privacyScrolled" class="text-success font-weight-bold">Anda telah membaca seluruh dokumen.</span>
        <div class="text-right">
          <button
            class="custom-btn-modal"
            :disabled="(!snkScrolled || !privacyScrolled) && !form.acceptTerms"
            @click="form.acceptTerms ? cancelTerms() : acceptTerms()"
          >
            {{ form.acceptTerms ? 'Batal Setuju' : 'Setuju' }}
          </button>
        </div>
      </div>
    </newCustomModal>
  </section>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import CustomModal from '../../components/CustomModal.vue';
import newCustomModal from '../../components/newCustomModal.vue';
import Agreement from '../../api/agreement.js';

export default {
  name: 'Login',
  components: {
    VueRecaptcha,
    CustomModal,
    newCustomModal
  },
  data() {
    return {
      showpassword: true,
      showConfirmPassword: true,
      loginFailAlert: false,
      form: {
        email: '',
        password: '',
        confirmPassword: '',
        acceptTerms: false, // Menyimpan status checkbox syarat dan ketentuan
        no_telpon: '',
        role_id: 3,
        userType: 'perorangan',
        referral_code: '',
      },
      errors: {
        userType: ''
      },
      message: '',
      loading: false,
      currentUser: '',
      emailNullModal: false,
      passwordCriteria: {
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false
      },
      passwordTouched: false,
      passwordFocused: false,
      sitekey: '6Lf0LVEaAAAAABqxdB_bDLHq-z8uuGzfiEPuDuBD',
      recaptchaVerified: false,
      phoneFocused: false,
      token: '',
      successModal: false,
      failedModal: false,
      failedMessage: '',
      modalVisible: false,
      modalTitle: '',
      modalMessage: '',
      showTermsModal: false,
      activeTab: 'snk',
      snkScrolled: false,
      privacyScrolled: false,
      snkContent: '',
      privacyContent: '',
      loadingTerms: false,
      loadingPrivacy: false,
      hasAcceptedTerms: false, 
      userType: '',
      disableReferralInput: false,
    };
  },
  computed: {
    passwordValid() {
      return this.passwordCriteria.uppercase && this.passwordCriteria.lowercase && this.passwordCriteria.number && this.passwordCriteria.specialChar;
    }
  },
  mounted() {
    const refCode = this.$route.query.ref;
    if (refCode) {
      this.form.referral_code = refCode;
      this.disableReferralInput = true;
    }
  },
  methods: {
    validate() {
      if (!this.form.userType) {
        this.errors.userType = 'Silakan pilih jenis nasabah.';
      } else {
        this.errors.userType = '';
      }
    },
    openTermsModal() {
      this.activeTab = 'snk';
      this.showTermsModal = true;
      this.$nextTick(() => {
        if (this.$refs.termsContent) {
          this.$refs.termsContent.scrollTop = 0;
        }
      });
      if (!this.snkContent) {
        this.fetchTermsContent();
      }
      if (!this.privacyContent) {
        this.fetchPrivacyContent();
      }
    },
    fetchTermsContent() {
      this.loadingTerms = true;

      // Fetch SNK from API
      Agreement.getActiveSnk()
        .then(res => {
          if (res.data && res.data.data) {
            this.snkContent = res.data.data.content;
          }
        })
        .catch(err => {
          console.error('Error fetching SNK:', err);
          this.snkContent = ''; // Will show fallback in template
        })
        .finally(() => {
          this.loadingTerms = false;
        });
    },
    fetchPrivacyContent() {
      this.loadingPrivacy = true;

      // Fetch Kebijakan Privasi from API
      Agreement.getActivePrivacy()
        .then(res => {
          if (res.data && res.data.data) {
            this.privacyContent = res.data.data.content;
          }
        })
        .catch(err => {
          console.error('Error fetching Kebijakan Privasi:', err);
          this.privacyContent = ''; // Will show fallback in template
        })
        .finally(() => {
          this.loadingPrivacy = false;
        });
    },
    handleScroll() {
      const el = this.$refs.termsContent;
      if (!el) return;

      const scrollBottom = el.scrollTop + el.clientHeight;
      const scrollHeight = el.scrollHeight;
      const isBottom = scrollBottom >= scrollHeight - 30;

      if (isBottom) {
        if (this.activeTab === 'snk' && !this.snkScrolled) {
          this.snkScrolled = true;
          // Automaticaly switch to privacy tab
          setTimeout(() => {
            this.activeTab = 'privacy';
            el.scrollTop = 0;
          }, 800);
        } else if (this.activeTab === 'privacy') {
          this.privacyScrolled = true;
        }
      }
    },
    normalizePhoneNumber(number) {
      if (!number) return '';

      // Hapus semua karakter selain angka
      let cleaned = number.replace(/\D/g, '');

      // Jika diawali 0, ganti jadi 62
      if (cleaned.startsWith('0')) {
        cleaned = '62' + cleaned.slice(1);
      }
      // Jika diawali 8 (tanpa 0), tambahkan 62 di depan
      else if (cleaned.startsWith('8')) {
        cleaned = '62' + cleaned;
      }
      // Jika sudah diawali 62, biarkan
      else if (cleaned.startsWith('62')) {
        // valid
      } else {
        // Kalau format tidak dikenali, kembalikan kosong atau bisa beri notifikasi
        console.warn('Format nomor tidak dikenali');
      }

      return cleaned;
    },
    onVerify(response) {
      this.token = response
      this.recaptchaVerified = true;
    },
    onExpired() {
      this.recaptchaVerified = false;
    },
    checkPasswordCriteria() {
      const password = this.form.password;

      this.passwordCriteria.uppercase = /[A-Z]/.test(password);
      this.passwordCriteria.lowercase = /[a-z]/.test(password);
      this.passwordCriteria.number = /[0-9]/.test(password);
      this.passwordCriteria.specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    },
    handleRegister() {
      const payload = { ...this.form };

      payload.phone = this.normalizePhoneNumber(this.form.no_telpon);
      payload.token = this.token;

      if (payload.userType === 'perorangan') {
        payload.role_id = 3;
      } else if (payload.userType === 'badan_hukum') {
        payload.role_id = 4;
      }

      this.loading = true;
      this.$store.dispatch('auth/register', payload)
        .then(res => {
          this.loading = false;

          if (res.meta.code === 422){
            if (res.data.referral_code){
              if (res.data.referral_code[0] === "The selected referral code is invalid.") {
                this.modalAction = "error";
                this.modalMessage = "Kode referal tidak valid.";
              } 
            } 
          } else if (res.meta.code !== 201) {
            this.modalAction = "error";
            this.modalMessage = res.meta.message;
          } else {
            this.modalAction = "success";
            this.modalMessage = "Akun Anda berhasil dibuat. Silakan <a href='/login'>login</a> untuk melanjutkan.";
          }

          this.modalVisible = true;
        })
        .catch((res) => {
          this.modalAction = "error";
          
          this.modalMessage = res.meta.message;
          this.modalVisible = true;
        });
    },
    onTermsCheckboxChanged(event) {
      if (!this.form.acceptTerms) {
        // If user tries to check it without having scrolled, show modal
        if (!this.snkScrolled || !this.privacyScrolled) {
          this.form.acceptTerms = false;
          this.openTermsModal();
        }
      } else {
        // If user unchecks it
        this.form.acceptTerms = false;
      }
    },
    acceptTerms() {
      if (this.snkScrolled && this.privacyScrolled) {
        this.form.acceptTerms = true;
        this.showTermsModal = false;
      }
    },
    cancelTerms() {
      this.form.acceptTerms = false;
      this.showTermsModal = false;
    },
    oke() {
      this.emailNullModal = false;
    },
  }
};
</script>

<style scoped>
.select-card {
  border: 2px solid #ccc;
  border-radius: 12px;
  padding: 5px;
  cursor: pointer;
  width: 200px;
  transition: all 0.3s ease;
  text-align: center;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.select-card:hover {
  border-color: #007bff;
}

.select-card.active {
  border-color: #007bff;
  background-color: #e6f0ff;
}

.select-card .img-select {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}
.password-container {
  position: relative;
}

.show-hide {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
}

.password-criteria ul {
  padding-left: 20px;
  font-size: 12px;
}

.password-criteria li {
  margin-bottom: 5px;
}

.custom-control-label {
  font-size: 14px;
}
/* Background transparan biru */
.custom-modal .modal-backdrop {
  background-color: rgba(0, 123, 255, 0.5); /* biru transparan */
}

/* Konten modal */
.custom-modal-content {
  background-color: rgba(0, 0, 50, 0.9); /* gelap transparan */
  border-radius: 20px;
  padding: 30px;
}

/* Tombol biru rounded */
.custom-btn {
  background-color: #007bff;
  color: white;
  border-radius: 30px;
  padding: 10px 25px;
  border: none;
}
.custom-btn:hover {
  background-color: #0056b3;
}
.modal-button-group {
  display: flex;
  justify-content: flex-end; /* Menarik tombol ke kanan */
  gap: 1rem;
  margin-top: 1.5rem;
}

.custom-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  min-width: 100px;
  text-align: center;
}
.custom-btn-modal {
  background-color: #007bff;
  color: white;
  border-radius: 30px;
  padding: 10px 25px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
}

.custom-btn-modal:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

.custom-btn.primary {
  background-color: #004990; /* Biru */
  color: #fff;
}

.custom-btn.danger {
  background-color: #dc3545; /* Merah */
  color: #fff;
}
/* Tambahan gaya agar card responsif */
.responsive-card {
  max-width: 600px;
  width: 100%;
  border-radius: 12px;
  background-color: #ffffff;
}
@media (max-width: 768px) {
  .responsive-card {
    max-width: 90%;
    padding: 1.5rem !important;
    margin: 1rem auto;
  }

  .responsive-card .form-group {
    margin-bottom: 1.25rem;
  }

  .responsive-card .form-control {
    font-size: 14px;
  }

  .responsive-card .select-card {
    width: 100%;
  }

  .responsive-card .img-select {
    width: 100%;
    height: auto;
  }

  .responsive-card .password-container {
    flex-direction: column;
  }

  .responsive-card button.custom-btn,
  .responsive-card button.btn {
    width: 100%;
  }

  .responsive-card .modal-button-group {
    flex-direction: column;
    gap: 10px;
  }
}

.terms-tabs .nav-tabs {
  border-bottom: 2px solid #edf2f7;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 1.5rem;
}

.terms-tabs .nav-link {
  border: none;
  color: #a0aec0;
  font-weight: 700;
  padding: 0.5rem 0;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  white-space: nowrap;
}

.terms-tabs .nav-link:hover {
  color: #4a5568;
}

.terms-tabs .nav-link.active {
  color: #004990 !important;
  border-bottom: 3px solid #004990;
  background: transparent;
}

.terms-tabs .nav-link.disabled {
  color: #e2e8f0;
  cursor: not-allowed;
}

.scroll-wrapper {
  max-height: 450px;
  overflow-y: auto;
  padding: 2.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.dynamic-content {
  font-family: 'Inter', sans-serif;
}

.dynamic-content >>> h1, 
.dynamic-content >>> h2, 
.dynamic-content >>> h3 {
  font-size: 1.5rem;
  color: #1a365d;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: 800;
  text-transform: uppercase;
}

.dynamic-content >>> p {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a5568;
  text-align: justify;
  margin-bottom: 1.25rem;
}

.dynamic-content >>> ul, 
.dynamic-content >>> ol {
  padding-left: 1.5rem;
  margin-bottom: 1.25rem;
}

.dynamic-content >>> li {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 0.75rem;
}

.custom-btn-modal {
  background-color: #004990;
  color: white;
  border-radius: 50px; /* Pill shape */
  padding: 10px 35px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
  font-weight: 600;
}

.custom-btn-modal:disabled {
  background-color: #cbd5e0;
  color: #718096;
  cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/public/auth/register.vue